import DeleteConfirmationModal from '@app/components/DeleteConfirmationModal'
import { externalActionCreators as signTransferActionCreators } from '@app/components/SignTransferModal/modules/signTransfer'
import { ISignTransfer } from '@app/models/SignTransfer'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

interface IPendingTransferItemProps {
  className?: string
  signTransfer: ISignTransfer
  style?: React.CSSProperties
}

interface IPendingTransferItemState {
  showDeleteConfirm: boolean
}

type PendingTransferItemProps = IPendingTransferItemProps &
  ICurrentUserState &
  typeof signTransferActionCreators

export default class PendingTransferItem extends React.PureComponent<
  PendingTransferItemProps,
  IPendingTransferItemState
> {
  constructor(props: PendingTransferItemProps) {
    super(props)
    this.state = {
      showDeleteConfirm: false,
    }
    bindFunctions(this)
  }

  public render() {
    if (!this.props.signTransfer.to) {
      return null
    }

    const itemClasses = classNames(
      'd-flex align-items-center px-2 py-1',
      this.props.className,
    )

    return (
      <div className={itemClasses} key={this.props.signTransfer.id}>
        <div className='flex-grow-1'>
          {this.props.signTransfer.quantity} to{' '}
          {this.props.signTransfer.to.name}
        </div>
        <div>
          <Link
            color='secondary'
            className='btn btn-outline-secondary btn-sm'
            target='_blank'
            title='View Assignment'
            to={`/assignment/${this.props.signTransfer.assignmentId}`}
          >
            <FontAwesomeIcon icon={['fal', 'clipboard-check']} fixedWidth />
          </Link>
          {this._canDelete() === true && (
            <Button
              className='ml-2'
              color='danger'
              onClick={this._onToggleDeleteConfirm}
              outline
              size='sm'
              title='Cancel Transfer'
            >
              <FontAwesomeIcon icon={['fal', 'trash']} fixedWidth />
              <DeleteConfirmationModal
                isOpen={this.state.showDeleteConfirm}
                itemName={`${this.props.signTransfer.quantity} ${this.props.signTransfer.signType.name} to ${this.props.signTransfer.to.name}`}
                onToggleModal={this._onToggleDeleteConfirm}
                onConfirm={this._onConfirmDelete}
              />
            </Button>
          )}
        </div>
      </div>
    )
  }

  private _canDelete() {
    return this.props.user !== undefined && !this.props.user.permissions.isGuest
  }

  private _onConfirmDelete() {
    this.props.deleteSignTransfer(this.props.signTransfer)
  }

  private _onToggleDeleteConfirm() {
    this.setState({ showDeleteConfirm: !this.state.showDeleteConfirm })
  }
}
